
    import { defineComponent, onMounted, ref } from 'vue'

    export default defineComponent({
        props: {
            dark: {
                type: Boolean,
                default: true
            },
            dense: {
                type: Boolean,
                default: false
            },
            disableTimeChange: {
                type: Boolean,
                default: false
            },
            downloadable: {
                type: Boolean,
                default: false
            },
            downloadUrl: {
                type: String,
                default: undefined
            },
            source: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: undefined
            },
            title: {
                type: String,
                default: undefined
            }
        },
        emits: [
            'paused',
            'started'
        ],
        setup (props, { emit }) {
            const audio = ref<HTMLAudioElement>()
            const elapsed = ref(0)
            const playing = ref(false)

            const toggle = async (): Promise<void> => {
                if (playing.value) {
                    emit('paused')
                    audio.value?.pause()
                } else {
                    emit('started', this)
                    await audio.value?.play()
                }

                playing.value = !playing.value
            }

            const updatePlayerTime = (percentage: number): void => {
                if (!audio.value) {
                    return
                }

                audio.value.currentTime = audio.value.duration * (percentage / 100)
            }

            onMounted(() => {
                audio.value?.addEventListener('timeupdate', (): void => {
                    if (!audio.value) {
                        return
                    }

                    elapsed.value = ((audio.value.currentTime / audio.value.duration) * 100)
                })
            })

            return {
                audio,
                elapsed,
                playing,
                toggle,
                updatePlayerTime
            }
        }
    })
